import React from 'react';
import LegalLayout, { H2, H3, P, UL } from '@/components/LegalLayout';

export default function CookiePolicyPage() {
  return (
    <LegalLayout eyebrow="LEGAL" title="Cookie Policy" updated="June 2026">
      <P>
        This Cookie Policy explains how Christovibes Radio uses cookies and similar technologies
        when you visit our website or use our mobile app. It sits alongside our
        <a className="text-[#D4AF37] hover:underline" href="/privacy"> Privacy Policy</a>.
      </P>

      <H2>1. What Are Cookies?</H2>
      <P>
        Cookies are small text files placed on your device when you visit a website. They help
        the site remember your actions and preferences (such as sign-in, language and playback
        settings) over a period of time. Similar technologies include local storage, session
        storage, and mobile-device identifiers.
      </P>

      <H2>2. Cookies We Use</H2>

      <H3>Strictly necessary (always on)</H3>
      <UL>
        <li><strong>Session & authentication</strong> — a token stored in your browser's local storage keeps administrators signed in and protects the site from cross-site request forgery.</li>
        <li><strong>Player state</strong> — remembers whether the radio player is playing or paused as you move between pages.</li>
      </UL>

      <H3>Preferences</H3>
      <UL>
        <li><strong>Language</strong> (mobile app) — remembers your English or Français preference.</li>
        <li><strong>Favorites</strong> (mobile app) — remembers shows you've hearted and prayers you've reacted to. Stored locally on your device only.</li>
      </UL>

      <H3>Third-party</H3>
      <UL>
        <li><strong>Streaming metadata</strong> — RadioBOSS/Icecast may set technical cookies to serve the audio stream reliably.</li>
        <li><strong>Object storage</strong> — Emergent Object Storage may set short-lived cookies while your uploaded audio is being received.</li>
      </UL>

      <P>
        We do <strong>not</strong> currently use advertising cookies, tracking pixels or cross-site behavioural
        profiling. If that ever changes, we will update this policy and, where required, ask for
        your consent first.
      </P>

      <H2>3. How Long Cookies Last</H2>
      <UL>
        <li><strong>Session cookies</strong> disappear when you close your browser or app.</li>
        <li><strong>Persistent cookies</strong> (like your language preference) remain until you clear your device storage or explicitly reset preferences.</li>
      </UL>

      <H2>4. Managing Cookies</H2>
      <P>You are in control of cookies. You can:</P>
      <UL>
        <li>Delete or block cookies through your browser settings (Chrome, Safari, Firefox, Edge each offer this).</li>
        <li>Clear the local storage for the Christovibes site to reset preferences.</li>
        <li>On mobile, uninstall the app to remove locally stored preferences and favorites.</li>
      </UL>
      <P>
        Please note that blocking strictly necessary cookies may break parts of Christovibes,
        including the admin dashboard and stream playback.
      </P>

      <H2>5. Do Not Track</H2>
      <P>
        Our systems currently do not respond to "Do Not Track" browser signals because we do not
        track your browsing behaviour across other sites. If we ever introduce such tracking, we
        will honour clear Do-Not-Track signals.
      </P>

      <H2>6. Changes</H2>
      <P>
        We may update this Cookie Policy from time to time. Material changes will be indicated by
        the "Last updated" date above.
      </P>

      <H2>7. Contact</H2>
      <P>
        For any question about how Christovibes uses cookies, email us at <a className="text-[#D4AF37] hover:underline" href="mailto:privacy@christovibes.com">privacy@christovibes.com</a>.
      </P>
    </LegalLayout>
  );
}
